document.addEventListener('mouseover', function (e) {

  const swatch = e.target.closest('.color-swatch-card');
  if (!swatch) return;

  const card = swatch.closest('.universal-product-card');
  if (!card) return;

  const img = card.querySelector('.product-main-image');
  if (!img) return;

  const newImage = swatch.dataset.image;
  if (!newImage) return;

  img.src = newImage;

});